import React from "react";
import { FormInput } from "../../../../htmlComponents/FormInput";
import { useReportContext } from "../../../../_context/ReportContext";
import { validateName } from "../../../Validations";
import { useNavigate } from "react-router-dom";

export const ClientGotConsent = () => {
  const { setNewReport, newReport } = useReportContext();
  const navigate = useNavigate();

  const updateConsentProviderName = (name: string) => {
    setNewReport(report => ({
      ...report,
      ClientConcent: { ...report.ClientConcent, Name: name }
    }));
  };

  const updateConsentProviderDesignation = (designation: string) => {
    setNewReport(report => ({
      ...report,
      ClientConcent: { ...report.ClientConcent, Designation: designation }
    }));
  };

  const handleProceedButtonClick = () => {
    setNewReport((report) => ({
      ...report,
      ClientConcent: {
        ...report.ClientConcent,
        ConcentProvided: true,
        SelfInspection: false,
        NoConcentReason: "",
      },
    }));
    navigate('/reports/create_new_report/scoring');
  };

  const isConsentProviderDetailsValid = () => {
    return (
      !validateName(newReport.ClientConcent.Name, true) &&
      !validateName(newReport.ClientConcent.Designation, true)
    );
  };

  return (
    <div className="au-card" style={{ animation: "auFadeIn 0.3s ease-out both" }}>
      <div className="au-card-body" style={{ padding: "24px" }}>
        <p style={{ fontWeight: 600, color: "#0f1c34", marginBottom: "16px" }}>
          Details of Consent Provider
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "20px" }}>
          <div>
            <FormInput
              id="consentProviderName"
              label="Provider Name"
              type="string"
              onChange={updateConsentProviderName}
              value={newReport.ClientConcent.Name}
              validator={validateName}
            />
          </div>
          <div>
            <FormInput
              id="consentProviderDesignation"
              label="Designation / Role"
              type="string"
              onChange={updateConsentProviderDesignation}
              value={newReport.ClientConcent.Designation}
              validator={validateName}
            />
          </div>
        </div>

        <button
          className="au-submit-btn"
          onClick={handleProceedButtonClick}
          disabled={!isConsentProviderDetailsValid()}
          style={{ background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)", boxShadow: "0 4px 14px rgba(22,163,74,0.3)" }}
        >
          Proceed to scoring
        </button>
      </div>
    </div>
  );
};
